// Filter (single)
export const FILTER_SINGLE_GET_PENDING = 'FILTER_SINGLE_GET_PENDING';
export const FILTER_SINGLE_GET_SUCCESS = 'FILTER_SINGLE_GET_SUCCESS';
export const FILTER_SINGLE_GET_FAILURE = 'FILTER_SINGLE_GET_FAILURE';

export const FILTER_SINGLE_FACILITIES_GET_PENDING = 'FILTER_SINGLE_FACILITIES_GET_PENDING';
export const FILTER_SINGLE_FACILITIES_GET_SUCCESS = 'FILTER_SINGLE_FACILITIES_GET_SUCCESS';
export const FILTER_SINGLE_FACILITIES_GET_FAILURE = 'FILTER_SINGLE_FACILITIES_GET_FAILURE';

export const FILTER_SINGLE_UPDATE_PENDING = 'FILTER_SINGLE_UPDATE_PENDING';
export const FILTER_SINGLE_UPDATE_SUCCESS = 'FILTER_SINGLE_UPDATE_SUCCESS';
export const FILTER_SINGLE_UPDATE_FAILURE = 'FILTER_SINGLE_UPDATE_FAILURE';

export const FILTER_SINGLE_FACILITIES_UPDATE_PENDING = 'FILTER_SINGLE_FACILITIES_UPDATE_PENDING';
export const FILTER_SINGLE_FACILITIES_UPDATE_SUCCESS = 'FILTER_SINGLE_FACILITIES_UPDATE_SUCCESS';
export const FILTER_SINGLE_FACILITIES_UPDATE_FAILURE = 'FILTER_SINGLE_FACILITIES_UPDATE_FAILURE';

export const FILTER_SINGLE_GENERAL_RULES_SET = 'FILTER_SINGLE_GENERAL_RULES_SET';
export const FILTER_SINGLE_GENERAL_PARAMETERS_SET = 'FILTER_SINGLE_GENERAL_PARAMETERS_SET';
export const FILTER_SINGLE_GENERAL_BRANDS_SET = 'FILTER_SINGLE_GENERAL_BRANDS_SET';
export const FILTER_SINGLE_GENERAL_NAME_SET = 'FILTER_SINGLE_GENERAL_NAME_SET';
export const FILTER_SINGLE_GENERAL_SUPPLIERS_SET = 'FILTER_SINGLE_GENERAL_SUPPLIERS_SET';
export const FILTER_SINGLE_GENERAL_CHANGED_SET = 'FILTER_SINGLE_GENERAL_CHANGED_SET';

export const FILTER_SINGLE_FACILITIES_PROPERTIES_SET = 'FILTER_SINGLE_FACILITIES_PROPERTIES_SET';
export const FILTER_SINGLE_FACILITIES_CATEGORIES_SET = 'FILTER_SINGLE_FACILITIES_CATEGORIES_SET';
export const FILTER_SINGLE_FACILITIES_BEDROOMS_SET = 'FILTER_SINGLE_FACILITIES_BEDROOMS_SET';
export const FILTER_SINGLE_FACILITIES_SITE_FACILITIES_SET = 'FILTER_SINGLE_FACILITIES_SITE_FACILITIES_SET';
export const FILTER_SINGLE_FACILITIES_CHANGED_SET = 'FILTER_SINGLE_FACILITIES_CHANGED_SET';

// Filter (list)
export const FILTER_LIST_BRANDS_SET = 'FILTER_LIST_BRANDS_SET';
export const FILTER_LIST_PRODUCTS_SET = 'FILTER_LIST_PRODUCTS_SET';
export const FILTER_LIST_ITEMS_PENDING = 'FILTER_LIST_ITEMS_PENDING';
export const FILTER_LIST_ITEMS_SUCCESS = 'FILTER_LIST_ITEMS_SUCCESS';
export const FILTER_LIST_ITEMS_FAILURE = 'FILTER_LIST_ITEMS_FAILURE';
export const FILTER_STATE_RESET = 'FILTER_STATE_RESET';
export const FILTER_LIST_CREATE_FILTER_PENDING = 'FILTER_LIST_CREATE_FILTER';
export const FILTER_LIST_CREATE_FILTER_SUCCESS = 'FILTER_LIST_CREATE_FILTER_SUCCESS';
export const FILTER_LIST_CREATE_FILTER_FAILURE = 'FILTER_LIST_CREATE_FILTER_FAILURE';

// Review
export const REVIEW_STATE_RESET = 'REVIEW_STATE_RESET';
export const REVIEW_ITEMS_PENDING = 'REVIEW_ITEMS_PENDING';
export const REVIEW_ITEMS_SUCCESS = 'REVIEW_ITEMS_SUCCESS';
export const REVIEW_ITEMS_FAILURE = 'REVIEW_ITEMS_FAILURE';

// Update approval status
export const REVIEW_APPROVAL_STATUS_APPROVE_PENDING = 'REVIEW_APPROVAL_STATUS_APPROVE_PENDING';
export const REVIEW_APPROVAL_STATUS_APPROVE_SUCCESS = 'REVIEW_APPROVAL_STATUS_APPROVE_SUCCESS';
export const REVIEW_APPROVAL_STATUS_APPROVE_FAILURE = 'REVIEW_APPROVAL_STATUS_APPROVE_FAILURE';

export const REVIEW_APPROVAL_STATUS_DISAPPROVE_PENDING = 'REVIEW_APPROVAL_STATUS_DISAPPROVE_PENDING';
export const REVIEW_APPROVAL_STATUS_DISAPPROVE_SUCCESS = 'REVIEW_APPROVAL_STATUS_DISAPPROVE_SUCCESS';
export const REVIEW_APPROVAL_STATUS_DISAPPROVE_FAILURE = 'REVIEW_APPROVAL_STATUS_DISAPPROVE_FAILURE';

// Update review information text
export const REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_PENDING = 'REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_PENDING';
export const REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_SUCCESS = 'REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_SUCCESS';
export const REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_FAILURE = 'REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_FAILURE';

// Review filter
export const REVIEW_FILTER_ITEMS_PENDING = 'REVIEW_FILTER_ITEMS_PENDING';
export const REVIEW_FILTER_ITEMS_SUCCESS = 'REVIEW_FILTER_ITEMS_SUCCESS';
export const REVIEW_FILTER_ITEMS_FAILURE = 'REVIEW_FILTER_ITEMS_FAILURE';

export const REVIEW_FILTER_UPDATE_SELECTED_BRANDS = 'REVIEW_FILTER_UPDATE_SELECTED_BRANDS';
export const REVIEW_FILTER_UPDATE_SELECTED_DOMAINS = 'REVIEW_FILTER_UPDATE_SELECTED_DOMAINS';

export const REVIEW_FILTER_RESET_REVIEWS = 'REVIEW_FILTER_RESET_REVIEWS';

export const REVIEW_FILTER_SITE_ITEMS_PENDING = 'REVIEW_FILTER_SITE_ITEMS_PENDING';
export const REVIEW_FILTER_SITE_ITEMS_SUCCESS = 'REVIEW_FILTER_SITE_ITEMS_SUCCESS';
export const REVIEW_FILTER_SITE_ITEMS_FAILURE = 'REVIEW_FILTER_SITE_ITEMS_FAILURE';
export const REVIEW_FILTER_UPDATE_SELECTED_SITES = 'REVIEW_FILTER_UPDATE_SELECTED_SITES';

// Bulk buttons
export const REVIEW_BULK_SELECT_ALL = 'REVIEW_BULK_SELECT_ALL';
export const REVIEW_BULK_DESELECT_ALL = 'REVIEW_BULK_DESELECT_ALL';
export const REVIEW_BULK_UPDATE_SELECT = 'REVIEW_BULK_UPDATE_SELECT';

// Review overview
export const REVIEW_OVERVIEW_PENDING = 'REVIEW_OVERVIEW_PENDING';
export const REVIEW_OVERVIEW_SUCCESS = 'REVIEW_OVERVIEW_SUCCESS';
export const REVIEW_OVERVIEW_FAILURE = 'REVIEW_OVERVIEW_FAILURE';

export const REVIEW_OVERVIEW_APPROVAL_STATUS_FILTER = 'REVIEW_OVERVIEW_APPROVAL_STATUS_FILTER';

// Review Settings
export const REVIEW_SETTINGS_STATE_RESET = 'REVIEW_SETTINGS_STATE_RESET';

export const REVIEW_SETTINGS_ITEMS_PENDING = 'REVIEW_SETTINGS_ITEMS_PENDING';
export const REVIEW_SETTINGS_ITEMS_SUCCESS = 'REVIEW_SETTINGS_ITEMS_SUCCESS';
export const REVIEW_SETTINGS_ITEMS_FAILURE = 'REVIEW_SETTINGS_ITEMS_FAILURE';

export const REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_PENDING = 'REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_PENDING';
export const REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_SUCCESS = 'REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_SUCCESS';
export const REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_FAILURE = 'REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_FAILURE';

export const REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_PENDING = 'REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_PENDING';
export const REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_SUCCESS = 'REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_SUCCESS';
export const REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_FAILURE = 'REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_FAILURE';

// App
export const APP_SESSION_INFO_SET = 'APP_SESSION_INFO_SET';

// Gift Voucher Templates
export const GIFT_VOUCHER_TEMPLATES_DOMAINS_PENDING = 'GIFT_VOUCHER_TEMPLATES_DOMAINS_PENDING';
export const GIFT_VOUCHER_TEMPLATES_DOMAINS_SUCCESS = 'GIFT_VOUCHER_TEMPLATES_DOMAINS_SUCCESS';
export const GIFT_VOUCHER_TEMPLATES_DOMAINS_FAILURE = 'GIFT_VOUCHER_TEMPLATES_DOMAINS_FAILURE';

export const GIFT_VOUCHER_TEMPLATES_SAVE_PENDING = 'GIFT_VOUCHER_TEMPLATES_SAVE_PENDING';
export const GIFT_VOUCHER_TEMPLATES_SAVE_SUCCESS = 'GIFT_VOUCHER_TEMPLATES_SAVE_SUCCESS';
export const GIFT_VOUCHER_TEMPLATES_SAVE_FAILURE = 'GIFT_VOUCHER_TEMPLATES_SAVE_FAILURE';

export const GIFT_VOUCHER_TEMPLATES_DOMAINS_SET = 'GIFT_VOUCHER_TEMPLATES_DOMAINS_SET';

export const GIFT_VOUCHER_TEMPLATES_PENDING = 'GIFT_VOUCHER_TEMPLATES_PENDING';
export const GIFT_VOUCHER_TEMPLATES_SUCCESS = 'GIFT_VOUCHER_TEMPLATES_SUCCESS';
export const GIFT_VOUCHER_TEMPLATES_FAILURE = 'GIFT_VOUCHER_TEMPLATES_FAILURE';
export const GIFT_VOUCHER_TEMPLATES_NO_CONTENT = 'GIFT_VOUCHER_TEMPLATES_NO_CONTENT';



// WEBPACK FOOTER //
// ./src/store/modules/constants.js